<template>
    <post-form
      :category-id="categoryId"
      :sub-category-id="subCategoryId"
      :category-url="categoryUrl"
      :sub-category-url="subCategoryUrl"
      @post-form-submitted="submitPost" :post-prop="post" :title="'Edition post ' + post.title" is-editing>
      <LoaderBox v-if="loading"/>
    </post-form>
</template>

<script>
  import PostForm from './PostForm'
  import LoaderBox from '../Loader/LoaderBox'
  import Swal from 'sweetalert2'
  import AppApiResponse from "../../AppApiResponse";
  export default {
    props: {
      categoryId: {type: Number},
      subCategoryId: {type: Number},
      categoryUrl: {type: String},
      subCategoryUrl: {type: String},
      postUrl: {type: String, required: true},
      post: {type: Object}
    },
    components: {PostForm, LoaderBox},
    data () {
      return {
        loading: false
      }
    },
    methods: {
      submitPost (post) {
        this.loading = true
        appAxios({
          method: 'PUT',
          url: this.postUrl.replace(':post', post.id),
          data: post,
          headers: {'content-type': 'application/json'},
        })
          .then(apiResponse => {
            Swal({
              type: 'success',
              title: apiResponse.getMessage(),
              timer: 3000,
              showConfirmButton: false,
              onClose () {
                window.location = `/post/${post.slug}-${post.id}`
              }
            })
          })
          .catch(apiResponse => {
            if (apiResponse instanceof AppApiResponse) {
              Swal({
                type: 'error',
                text: apiResponse.getMessage(),
                timer: 3000,
                showConfirmButton: false
              })
            }
          })
          .then(_ => this.loading = false)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/component/Post/PostEdit.vue